import { OrderDetails, OrderItem, ProductOrderItem } from 'types/api/orders.type';

/**
 * Augments every order item with a stable `uniqueId` for React keys / delete
 * tracking. Prefers the API-provided `itemId` when available, falling back to
 * a deterministic composite key.
 */
const buildUniqueId = (item: OrderItem, index: number): string => {
  if (item.itemId) return item.itemId;
  const code = item.productCode ?? '';
  const colour = item.productColorCode ?? '';
  const fabric = item.mainFabricCode ?? '';
  return `${code}-${fabric}-${colour}-${index}`;
};

export const addUniqueIdsToTheItems = (order: OrderDetails): OrderDetails => {
  const items = order.items?.map(
    (item, index): ProductOrderItem => ({
      ...item,
      uniqueId: buildUniqueId(item, index),
    })
  );

  return { ...order, items: items ?? [] };
};

/** @deprecated Use {@link addUniqueIdsToTheItems}. */
export const addUniqueIdsToTheProducts = addUniqueIdsToTheItems;
